function deprecated(validator, message) {
  return (...args) => {
    const [props, propName, displayName] = args;
    if (props[propName] !== void 0) {
      if (message) {
        console.warn(`${displayName}: ${propName} is deprecated. ${message}`);
      } else {
        console.warn(`${displayName}: ${propName} is deprecated.`);
      }
    }
    return validator(...args);
  };
}
export {
  deprecated
};
